import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { POST, PATCH, PUT } from '../common/consts';

const getUserRobotsAPI = async ({ userId, ...rest }) => {
  const res = await fetch(
    `${API_URL}robots/${userId}?${encodeGetParams(rest)}`,
  );
  const result = res.json();
  return result;
};

const getUserGroupsAPI = async ({ userId }) => {
  const res = await fetch(`${API_URL}groups/${userId}`);
  const result = res.json();
  return result;
};

const setUserRobotsAPI = async ({ userId, robots }) => {
  const res = await fetch(
    `${API_URL}robots`,
    getHeaders(POST, { userId, robots }),
  );
  const result = res.json();
  return result;
};

const updateUserRobotsAPI = async ({ userId, robots, groups }) => {
  const res = await fetch(
    `${API_URL}robots`,
    getHeaders(PATCH, { userId, robots, groups }),
  );
  const result = res.json();
  return result;
};

const deleteUserRobotsAPI = async ({ userId, robots }) => {
  const res = await fetch(
    `${API_URL}robots`,
    getHeaders(PUT, { userId, robots }),
  );
  const result = res.json();
  return result;
};

const initRobotAPI = async ({ robotId }) => {
  const res = await fetch(
    `${API_URL}robotInit`,
    getHeaders(PATCH, { robotId }),
  );
  const result = res.json();
  return result;
};

const getRobotDashboardDataAPI = async ({ userId }) => {
  const res = await fetch(`${API_URL}dashboard/${userId}`);
  const result = res.json();
  return result;
};

const getRobotDataAPI = async ({ robotId }) => {
  const res = await fetch(`${API_URL}robot/${robotId}`);
  const result = res.json();
  return result;
};

const updateRobotDataAPI = async ({ robotId, updateData }) => {
  const res = await fetch(
    `${API_URL}robot/${robotId}`,
    getHeaders(PATCH, { ...updateData }),
  );
  const result = res.json();
  return result;
};

// const checkSerialAPI = async ({ serial }) => {
//   const res = await fetch(`${API_URL}checkSerial/${serial}`);
//   const result = res.json();
//   return result;
// };

export {
  getUserRobotsAPI,
  getUserGroupsAPI,
  setUserRobotsAPI,
  updateUserRobotsAPI,
  deleteUserRobotsAPI,
  initRobotAPI,
  getRobotDashboardDataAPI,
  getRobotDataAPI,
  updateRobotDataAPI,
  // checkSerialAPI,
};
